import React from "react";

const Navigation = () => {
  return (
    <div>
      <nav className="bg-slate-100 shadow-md">
        <div className="max-w-7xl mx-auto px-5 lg:px-0 flex justify-between py-3 items-center">
          <a href="index.html">
            <img
              className="h-10"
              src="https://www.freeiconspng.com/thumbs/blogger-logo-icon-png/blogger-logo-icon-png-10.png"
              alt="Learn with Sumit"
            />
          </a>
        </div>
      </nav>
    </div>
  );
};

export default Navigation;
